import React from 'react'

const Badge = ({title, color_code}) => {
  return (
    <span class="badge rounded-pill text-white px-2" style={{backgroundColor: `${color_code}`, fontSize: "12px"}}>{title}</span>
  )
}

export default Badge